import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import theme from '../../styles/theme';
import { rem } from '../../styles/theme/layout';

const wrapper = css`
  background: ${theme.colors.footerBg};
  color: ${theme.colors.footerText};
  padding: ${rem(15)} ${rem(15)} ${rem(30)};
  font-size: 1rem;
`;

const linkClass: SerializedStyles = css`
  color: ${theme.colors.footerText};
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: ${theme.colors.white};
  }
  &:after {
    content: '|';
    padding-left: ${theme.space[1]};
    padding-right: ${theme.space[1]};
  }
`;

const menuLink: SerializedStyles = css`
  flex-wrap: wrap;
  line-height: ${rem(28)};

  > div:last-child,
  > a {
    &:after {
      content: ' ';
      padding-right: 0;
    }
  }
`;

export const ManageCookie = styled.button`
  background: ${theme.colors.whiteSecondary};
  color: ${theme.colors.black};
  font-size: ${theme.fontSizes[1]};
  font-weight: bold;
  display: block;
  border: 0;
  padding: ${rem(4)} ${rem(6)};
  margin: 0 ${rem(8)};
  align-self: center;
`;

export default {
  wrapper,
  linkClass,
  menuLink,
  ManageCookie,
};
